import { ReactNode } from "react";

const BULLET = /^\s*[-*•]\s+/;

// Remarks are plain text: lines starting with "-", "*" or "•" become a
// bulleted list, other lines stay paragraphs.
function formatRemarks(remarks: string) {
  const blocks: ReactNode[] = [];
  let items: string[] = [];
  const flushList = () => {
    if (!items.length) return;
    blocks.push(
      <ul key={blocks.length} className="list-disc pl-5">
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
    items = [];
  };

  remarks.split("\n").forEach((line) => {
    if (BULLET.test(line)) {
      items.push(line.replace(BULLET, ""));
      return;
    }
    flushList();
    if (line.trim()) blocks.push(<p key={blocks.length}>{line}</p>);
  });
  flushList();
  return blocks;
}

export function DistributorRemarks({ remarks }: { remarks: string }) {
  return (
    <div className="flex min-h-36 flex-col gap-5 rounded-2xl border border-border bg-tag-slate p-4">
      <span className="font-semibold">Distributor Remarks</span>
      <div className="flex flex-col gap-2 text-muted-foreground">
        {formatRemarks(remarks)}
      </div>
    </div>
  );
}
